import { makeStyles } from "@material-ui/core";
import { blue, grey } from "@material-ui/core/colors";
import { Colors } from "../../constants";

export default makeStyles((theme) => ({
  typedBox: {
    width: "100%",
    height: "120px",
    border: `1px dashed ${blue[400]}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  fontPlayball: {
    fontFamily: "Playball !important",
  },
  fontNoteworthy: {
    fontFamily: "Noteworthy !important",
  },
  fontMarckScript: {
    fontFamily: "Marck Script !important",
  },
  fontSofia: {
    fontFamily: "Sofia !important",
  },
  div: {
    fontSize: "24px",
    textAlign: "center",
    outline: "none",
    width: "100%",
    overflowWrap: "anywhere",
    // Horizontal breathing room so html2canvas (which sizes to the layout
    // box, not the glyph ink box) doesn't clip the swashes / italic overhang
    // of the cursive fonts on the left & right edges. A little vertical
    // padding guards tall ascenders/flourishes too.
    padding: theme.spacing(0.5, 2.5),
    boxSizing: "border-box",
  },
  colorBlack: {
    color: "black",
  },
  colorDarkBlue: {
    color: Colors.DarkBlue,
  },
  colorBlue: {
    color: Colors.Blue,
  },
  defaultText: {
    color: grey[300],
    textTransform: "uppercase",
    fontSize: "24px",
    fontWeight: 400,
  },
  signatureBox: {
    width: "100%",
    maxWidth: "100%",
  },
  alert: {
    marginBlock: theme.spacing(2),
  },
}));
